module.exports = __webpack_public_path__ + "img/LogoCliente.f3baaa05.png";